import "@fontsource/inter";

// ** MUI
import { Container, createTheme, ThemeProvider } from "@mui/material";

// ** Components

import Navigation from "../layout/AppBar";

// ** Styles
import Footer from "../layout/Footer";
import "../styles/global.css";
import "prism-themes/themes/prism-night-owl.css";

const theme = createTheme({
  typography: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif', // Set Inter as the primary font
  },
});
export default function MyApp({ Component, pageProps }) {
  const getLayout = Component.getLayout || ((page) => page);

  return (
    <ThemeProvider theme={theme}>
      {getLayout(<Component {...pageProps} />)}
    </ThemeProvider>
  );
}
